import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import { Colors } from "~/config/Colors";
import {
  SLEditModal,
  SLCreateModal,
} from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";
import TableComponent from "./TableComponent";

export default function Dispositivos() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil, idUnidades, controle } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));
    }

    handleRequests();

    api.get('/signed/cliente/administracao/organizacao/unidades', { params: { centroCusto: "S" } }).then(response => {
      let lista = [];
      for (const item of idUnidades) {
        const itemFind = response?.data?.find((o) => o?.id == item);
        
        if (itemFind) {
          let listaCC = [];
          for (const itemCC of itemFind?.centroCustos) {
            listaCC.push({ id: itemCC?.id, titulo: itemCC?.titulo });
          }

          lista.push({ id: itemFind?.id, titulo: itemFind?.nome, centroCustos: listaCC });
        }
      }
      setUnidades(lista);
    });
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get('/signed/cliente/gestorservico/gerenciamento/dispositivos', { params: { tipo: "A" } }),
              findOne: thisData =>
                api.get('/signed/cliente/gestorservico/gerenciamento/dispositivo', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/cliente/gestorservico/gerenciamento/dispositivo', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Dispositivos',
              subTitle: "Adiocione os Dispositivos",
              icone: 'submenu-dispositivo',
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 0,
              list: [
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Ativo',
                  value: { ativo: true },
                },
                {
                  corDestaque: localStorage.getItem("tema") == "E" ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
              ],
            }}
            pageSize={7}
            inputs={[
              { filter: 'titulo', label: 'Titulo' },
              { filter: 'codigoDevice', label: 'Device' },
            ]}
            selects={[
              {
                list: unidades,
                value: "id",
                label: "titulo",
                outLabel: "Todas Unidades",
                filter: "idUnidade",
              },
            ]}
          >
            <SLEditModal title="Atualizar Dispositivo" setter={setMountedData}>
              {mountedData && modulos && (
                <CreateEditContent {...{ modulos, mountedData, unidades }} />
              )}
            </SLEditModal>

            <SLCreateModal title="Adicionar Dispositivo">
              {modulos && <CreateEditContent {...{ modulos, unidades }} />}
            </SLCreateModal>

            <TableComponent />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
